import LegalEntity from "./LegalEntity";
import IndividualPerson from "./IndividualPerson";
import { entityTypes } from "../../static/types/objectType";
import { IndividualPersonType } from "../../static/types/commonTypes/individualType";
import { LegalEntityType } from "../../static/types/commonTypes/legalEntityType";
import { initialIndividualState } from "../../static/initialState/commonInitialState/individualInitialState";
import { initialLegalEntityState } from "../../static/initialState/commonInitialState/legalEntityInitalState";
import { ManagerTypeWithQualite } from "../../static/types/commonTypes/managerType";

type ManagerWithQualitiesProps = {
  checked: boolean;
  manager: ManagerTypeWithQualite;
  qualitiesOptions: string[];
  societyType?: string | string[];
  setChecked: (checked: boolean) => void;
  setManager?: (manager: ManagerTypeWithQualite | any) => void;
  updateManagerValidity: (isValid: boolean) => void;
};

export default function ManagerWithQuality({
  checked,
  manager,
  qualitiesOptions,
  setManager,
  setChecked,
  societyType,
  updateManagerValidity,
}: ManagerWithQualitiesProps) {
  const updateEntityDetails = (details: Partial<IndividualPersonType | LegalEntityType>) => {
    if (setManager) {
      setManager((prev: any) => {
        if (prev.person === "Personne physique") {
          return { ...prev, personDetails: { ...prev.personDetails, ...details } };
        } else {
          return { ...prev, entityDetails: { ...prev.entityDetails, ...details } };
        }
      });
    }
  };

  const handlePersonChange = (person: "Personne physique" | "Personne morale") => {
    if (setManager) {
      setManager(
        person === "Personne physique"
          ? { person, personDetails: initialIndividualState }
          : { person, entityDetails: initialLegalEntityState }
      );
    }
    setChecked(false);
  };

  return (
    <div className="tab-content">
      <div className="mb-3 row">
        <label htmlFor="personne" className="col-sm-2 col-form-label">
          Personne
        </label>
        <div className="col-sm-10">
          <select
            className="form-select"
            id="person"
            onChange={(e) => handlePersonChange(e.target.value as "Personne physique" | "Personne morale")}
            value={manager?.person || ""}
          >
            {entityTypes.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="qualities" className="col-sm-2 col-form-label">
          Qualité
        </label>
        <div className="col-sm-10">
          <select className="form-select" id="qualities">
            {qualitiesOptions.map((quality) => (
              <option key={quality} value={quality}>
                {quality}
              </option>
            ))}
          </select>
        </div>
      </div>

      {manager.person === "Personne physique" && (
        <IndividualPerson
          checked={checked}
          individual={manager.personDetails}
          changeIndividual={updateEntityDetails}
          onValidationChange={updateManagerValidity}
        />
      )}

      {manager.person === "Personne morale" && (
        <LegalEntity
          checked={checked}
          legalEntity={manager.entityDetails}
          changeLegalEntity={updateEntityDetails}
          societyType={societyType}
          onValidationChange={updateManagerValidity}
        />
      )}
    </div>
  );
}
